<div class="row text-primary py-4 container mx-auto">
  <div class="col-12 col-md-3">
    <div class="bg-white rounded py-3 px-2 text-center">
      <h4>Questions</h4>
      <div class="d-flex justify-content-center align-items-center flex-wrap mt-2">
        <ng-container *ngFor="let item of questions; index as i; trackBy: trackByIndex">
          <ng-container *ngFor="let question of item.questions; index as j; trackBy: trackByIndex">
            <div class="question-pin shadow rounded-circle d-flex justify-content-center align-items-center bolder m-2"
                 [class.bg-primary]="isAnswered(question)"
                 [class.text-white]="isAnswered(question)">
              {{ getIndex(i, j) }}
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-9">
    <div class="bg-white rounded p-4">
      <h4 class="mb-2">Listening part 3: Conversations</h4>
      <p>
        You are going to listen to short conversations between two or more people, each with 3 questions. For each question, choose the answer which you think fits best according to what you hear.
      </p>
      <p>
        There are 39 questions in this test.
      </p>
    </div>

    <div class="bg-white rounded p-4 mt-3">
      <div class="text-center w-50 mx-auto bg-light shadow text-primary py-2 px-4 rounded bolder">
        {{ displayDuration(currentTime) }} /&nbsp;<span class="text-muted">{{ displayDuration(totalTime) }}</span>
      </div>
      <audio #audioPlayer controls hidden></audio>
    </div>

    <!-- Questions -->
    <div class="bg-white rounded p-4 mt-3" *ngFor="let item of questions; index as i; trackBy: trackByIndex">
      <h5 class="mb-3 bolder text-center">Dialogue {{ i+1 }}.</h5>
      <div class="mt-2">
        <ng-container *ngFor="let question of item.questions; index as j; trackBy: trackByIndex">
          <div class="mb-4">
            <h5 class="mb-2"><span class="font-weight-lighter text-muted">{{ getIndex(i, j) }}. </span>{{question.translation}}</h5>
            <div class="d-flex flex-column justify-content-evenly align-items-center">
              <ng-container *ngFor="let answer of question.answers; let questionIndex = index; trackBy: trackByIndex">
                <button class="btn rounded btn-block shadow bolder mx-2 h-100 text-left p-3"
                        [class.btn-primary]="isSelected(question, answer)"
                        [class.text-white]="isSelected(question, answer)"
                        [class.btn-white]="!isSelected(question, answer)"
                        [class.text-primary]="!isSelected(question, answer)"
                        (click)="selectAnswer(question, answer)">
                  <span class="mr-2 bolder">{{ letters[questionIndex] }}</span> {{answer.translation}}
                </button>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </div>


    <button class="btn btn-primary btn-block bolder mt-3" (click)="next()" translate>Suivant</button>
  </div>
</div>
